<template>
  <page :toolbar="toolbar">
    <template v-slot:content>
      <div>
        <v-divider></v-divider>
        <v-tabs v-model="tab" fixed-tabs background-color="grey lighten-5" color="primary">
          <v-tab v-for="(item, index) in tabItems" :key="index">
            {{
            item
            }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <account-settings></account-settings>
          </v-tab-item>
          <v-tab-item>
            <user-settings></user-settings>
          </v-tab-item>
          <v-tab-item>
            <default-settings></default-settings>
          </v-tab-item>
          <v-tab-item>
            <import-settings></import-settings>
          </v-tab-item>
          <v-tab-item v-if="isOwner">
            <owner-settings></owner-settings>
          </v-tab-item>
        </v-tabs-items>

        <router-view></router-view>
      </div>
    </template>
  </page>
</template>

<script>
import { mapState, mapActions } from "vuex";

import accountSettings from "./account";
import userSettings from "./users";
import defaultSettings from "./defaults";
import importSettings from "./import";
import ownerSettings from "./owner";

export default {
  components: {
    accountSettings,
    userSettings,
    ownerSettings,
    importSettings,
    defaultSettings
  },
  data() {
    return {
      tab: 0
    };
  },
  methods: {
    route(routeName) {
      this.$router.push({ name: routeName });
    }
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
    currentUser() {
      return this.account.user;
    },
    isOwner() {
      return this.currentUser.role == "owner";
    },
    tabItems() {
      var tabs = ["Account", "Users & Locations", "Defaults", "Import/Export"];
      if (this.isOwner) {
        tabs.push("Owner Defaults");
      }
      return tabs;
    },
    toolbar() {
      return {
        title: "Settings"
      };
    }
  }
};
</script>
